import { useMemo } from 'react';
import { prop } from 'ramda';
import { useParams } from 'react-router-dom';
import { htcmdService } from 'js/services/htcmd.service';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import { SPORTS_OVERLAYS_ID } from '../constants';

export const useGetInitParams = () => {
    const { pathLang } = useParams();
    const lang = useUserSelector(prop('lang'));
    const defaultLanguage = useAppSelector(prop('defaultLocale'));
    const defaultCurrency = useAppSelector(prop('defaultCurrency'));
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));

    return useMemo(() => ({
        APIVersion: 4,
        uiContext: htcmdService.isEnabled || htcmdService.isWrapperEnabled ? 'native' : null,
        language: (lang || defaultLanguage).replace('_', '-'),
        currencyCode: defaultCurrency,
        getSessionInfoFn: async () => null,
        overlayContainerId: SPORTS_OVERLAYS_ID,
        routingPrefix: pathLang ? `/${pathLang}${sportsbookRootURL}` : sportsbookRootURL
        // language dependencies must be same as in useSportsbookDestroyOnLangChange
    }), [lang, pathLang, defaultCurrency, defaultLanguage, sportsbookRootURL]);
};
